/* eslint-disable no-undef */
import React, { useState, useContext, useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Layout, Menu } from 'antd'
import { RightCircleOutlined, LeftCircleOutlined } from '@ant-design/icons'
import { SettingContext } from '../../store/SettingProvider'
import { DashboardContext as TimeLineDashboard } from '../../store/TimeLineDashboardProvider'
import { AuthContext } from '../../store/AuthProvider'
import useAlertLogList2 from '../../hook/useAlertLogList2'
import logo from '../../images/logo.svg'
import logo_w from '../../images/logo_w.svg'
import logo_icon from '../../images/logo_icon.svg'
import { menu } from '../../functionTool/functionTool'

const { Sider } = Layout

function searchKey(data = [], targetKey) {
    let results = [];
  
    for (let item of data) {
      if (item.key === targetKey) {
        results.push(item);
      }
  
      if (item.children) {
        results = results.concat(searchKey(item.children, targetKey));
      }
    }

    return results;
}

const Sidebar = () => {
    const [collapsed, setCollapsed] = useState(true)
    const { dark, customerSettings } = useContext(SettingContext)
    const { customTimeLineMode } = useContext(TimeLineDashboard)
    const { user } = useContext(AuthContext)
    const { alertLogList2 } = useAlertLogList2({ expired: 'false' })

    //客戶dark logo url
    const darkLogoURL = customerSettings?.[0]?.profileInfo?.darkLogoURL || logo_w

    //客戶dark logo url - simple
    const darkLogoSimpleURL = customerSettings?.[0]?.profileInfo?.darkLogoSimpleURL || logo_icon

    //客戶light logo url
    const logoURL = customerSettings?.[0]?.profileInfo?.logoURL || logo

    //客戶light logo url - simple
    const logoSimpleURL = customerSettings?.[0]?.profileInfo?.logoSimpleURL || logo_icon

    const location = useLocation()

    //判斷是否顯示嚴重程度：次要、提示，ABNORMAL_all-degree表示顯示所有嚴重程度
    const showAllDegree = useMemo(() => {
        return user.roleList?.[0].operations?.[0] === 'ABNORMAL_all-degree'
    }, [user])
    
    //錯誤訊息數量
    const alerNumber = alertLogList2?.vpp_getAlertLogList2?.filter?.(
        (item) => item.expired !== 'true' && (showAllDegree || item.alertLevel !== 'medium' && item.alertLevel !== 'low')
    )?.length

    //展示帳號
    const isDemoAccount = user.userName === '展示' && process.env.REACT_APP_STAGE_NAME === '開發區'

    const isDemo = process.env.REACT_APP_STAGE_NAME === '開發區' && customTimeLineMode

    const filterMenu = useMemo(() => menu({
        alert: alerNumber,
        customTimeLineMode: isDemo,
        menuList: user?.menuList || [],
    }),[alerNumber, isDemo, user?.menuList])

    // 展示帳號需過濾掉指定頁面
    const finalMenu = useMemo(() => {
        if (!isDemoAccount) return filterMenu
        const disallowedKeys = new Set([
            '/analysis',            // 分析報告
            '/greenenergyinfo',     // 綠電資訊報表（整組）
            '/emsreport',           // 維運與成效報告
            '/device',              // 能源設備總覽
            '/contractconfig',      // 契約容量管理
        ])

        const prune = (items = []) => {
            return items.reduce((acc, item) => {
                if (disallowedKeys.has(item.key)) return acc
                let newItem = { ...item }
                if (item.children && item.children.length) {
                    const children = prune(item.children)
                    if (children.length) {
                        newItem.children = children
                    } else {
                        delete newItem.children
                    }
                }
                acc.push(newItem)
                return acc
            }, [])
        }

        return prune(filterMenu)
    }, [isDemoAccount, filterMenu])

    const currentSelectedMenuKey = useMemo(() => {
        if (location.pathname === '/') return '/';
    
        const pathSnippets = location.pathname.split('/').filter((i) => i);
    
        let menuKey = '';
        for (let i = pathSnippets.length; i > 0; i--) {
          const url = `/${pathSnippets.slice(0, i).join('/')}`;
          // const matchMenu = MenuList.find((f) => f.key === url);
          const matchMenu = searchKey(finalMenu, url);
          if (matchMenu.length) {
            menuKey = matchMenu[0].key;
            break;
          }
        }
    
        return menuKey;
    }, [location, finalMenu]);

    return (
        <Sider
            collapsible
            className="app-aside"
            collapsed={collapsed}
            collapsedWidth={60}
            onCollapse={(value) => setCollapsed(value)}
            trigger={
                collapsed ? <RightCircleOutlined /> : <LeftCircleOutlined />
            }
            style={{
                overflow: 'auto',
                height: '100vh',
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
            }}
        >
            <div className="app-logo-wrap">
                <div
                    className={`app-logo ${
                        !collapsed ? '' : 'app-logo-collapsed'
                    }`}
                >
                    {!collapsed ? (
                        <Link to="/">
                            <img
                                src={dark ? darkLogoURL : logoURL}
                                alt="微電能源-能源管理系統"
                            />
                        </Link>
                    ) : (
                        <Link to="/">
                            <img src={dark ? darkLogoSimpleURL : logoSimpleURL} alt="微電能源-能源管理系統" />
                        </Link>
                    )}
                </div>
            </div>
            <Menu
                theme={dark ? 'dark' : 'light'}
                mode="inline"
                className="app-aside-menu"
                inlineIndent={16}
                selectedKeys={[currentSelectedMenuKey]}
                items={finalMenu}
            />
        </Sider>
    )
}

export default Sidebar
